import { render, staticRenderFns } from "./ConfigInformation.vue?vue&type=template&id=cd07c63a&scoped=true&"
import script from "./ConfigInformation.vue?vue&type=script&lang=js&"
export * from "./ConfigInformation.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInformation.vue?vue&type=style&index=0&id=cd07c63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd07c63a",
  null
  
)

export default component.exports